import React from "react";
import { Box, Typography, Container, Grid } from "@mui/material";
import { useContent } from "../context/ContentContext";

export default function Footer() {
  const content = useContent();
  const company = content.getCompany();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#f9f9f9",
        color: "black",
        py: 2,
        mt: 4,
        borderTop: "1px solid #e0e0e0",
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ textAlign: "center", mt: 3 }}>
          <Typography variant="body2">
            © {new Date().getFullYear()} {company.name || "SLN Advertising & Printing"}. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
